import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Dropdown from "react-bootstrap/Dropdown";
import { HomePage } from "../../../translations/trans";
import { useDispatch, useSelector } from "react-redux";
import { Get_Mocks } from "../../../actions/mockAction";
import ShowFileMock from "./ShowFileMock";
import UpdateMock from "./UpdateMock";
import DeleteMock from "./DeleteMock";
import { urlBase } from "../../../utils/API";
import { toggelMockStatus } from "../../../utils/mock";
import { ErrorMsg, success } from "../../../utils/Toast";

const ShowMocks = ({ materialId, mocks, userId }) => {
  const [show, setShow] = useState(false);
  const [selectedDescription, setSelectedDescription] = useState(null);
  const { lang, dir,user } = useSelector(({ language,loggedUser }) => ({
    lang: language.lang,
    dir: language.dir,
    user:loggedUser?.user
  }));
// console.log(user)
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const dispatch = useDispatch();

  const handleallMocks = async () => {
    try {
      await dispatch(Get_Mocks(materialId));
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    handleallMocks();
  }, []);

  const handleShowFullDescription = (description) => {
    setSelectedDescription(description);
  };

  const handleToggleStatus = async (id) => {
    try {
      const res= await toggelMockStatus({ id, userId:user?._id });
      await handleallMocks(); // refresh list after toggle
      success(res?.data?.message)
    } catch (err) {
      console.error("Error toggling status:", err);
      ErrorMsg(err?.message)
    }
  };

  return (
    <div>
      <Button variant="primary" onClick={handleShow}>
        {HomePage.showMocks[lang]}
      </Button>

      <Modal show={show} onHide={handleClose} centered dir={dir} size="lg">
        <Modal.Header>
          <Modal.Title>{HomePage.showMocks[lang]}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table className="table">
            <thead>
              <tr>
                <th>{HomePage.name[lang]}</th>
                <th>{HomePage.desc[lang]}</th>
                <th>{HomePage.onlyfile[lang]}</th>
                <th>{HomePage.actions[lang] || "Actions"}</th>
              </tr>
            </thead>
            <tbody>
              {mocks?.map((mock) => (
                <tr key={mock?._id}>
                  <td>{mock?.name}</td>
                  <td>
                    {mock?.description?.slice(0, 10)}...
                    <span
                      style={{ color: "blue", cursor: "pointer" }}
                      onClick={() =>
                        handleShowFullDescription(mock?.description)
                      }
                    >
                      {HomePage.learnMore[lang]}
                    </span>
                  </td>
                  <td>
                    {mock?.file ? (
                      <ShowFileMock mockFile={`${urlBase}/${mock?.file}`} />
                    ) : (
                      <p>{HomePage.noFile[lang]}</p>
                    )}
                  </td>

                  {/* Actions Dropdown */}
                  <td>
                    <Dropdown>
                      <Dropdown.Toggle variant="secondary" size="sm">
                        {HomePage.options[lang] || "Options"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item as="div">
                          <UpdateMock mock={mock} materialId={materialId} />
                        </Dropdown.Item>
                        <Dropdown.Item
                          onClick={() =>
                            handleToggleStatus(mock?._id)
                          }
                        >
                          {mock?.active
                            ? HomePage.deactivate[lang] || "Deactivate"
                            : HomePage.activate[lang] || "Activate"}
                        </Dropdown.Item>
                        <Dropdown.Item as="div">
                          <DeleteMock mock={mock?._id} materialId={materialId} />
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {selectedDescription && (
            <div
              className="full-description-popup"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                backgroundColor: "white",
                padding: "20px",
                border: "1px solid #ccc",
                boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
                zIndex: 1000,
              }}
            >
              <p>{selectedDescription}</p>
              <Button
                variant="secondary"
                onClick={() => setSelectedDescription(null)}
              >
                Close
              </Button>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {HomePage.close[lang]}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ShowMocks;
